import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  organisationEmailCheckAction,
  organisationSendInviteAction,
} from "../Redux/Action/organisationAction";
import { getActiveGroup } from "../OrganisationGroups/utils/roleAccess";

const InviteMemberOrganisationModal = ({ show, handleClose, onInviteSent }) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.authSlice.userData?.payload);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isInviteLoading, setIsInviteLoading] = useState(false);
  const [checkedResult, setCheckedResult] = useState(null);
  const [showAgreementModal, setShowAgreementModal] = useState(false);
  const [isAgreementAccepted, setIsAgreementAccepted] = useState(false);

  const organisationGroupId = getActiveGroup(userData)?._id;
  const checkedPayload =
    checkedResult?.data || checkedResult?.payload?.data || {};
  const checkedType = checkedPayload?.type;
  const checkedMessage =
    checkedResult?.data?.message ||
    checkedPayload?.message ||
    checkedResult?.payload?.message ||
    "";
  const checkedSchool =
    checkedPayload?.school ||
    checkedPayload?.schoolData ||
    checkedPayload?.organisation ||
    checkedPayload?.memberOrganisation ||
    null;

  const canSendInvite =
    Boolean(checkedResult) &&
    (checkedType === "SCHOOL_SUPER_ADMIN" ||
      checkedType === "NON_SUPER_ADMIN") &&
    Boolean(email.trim()) &&
    Boolean(organisationGroupId);

  const handleSearch = async () => {
    if (!email.trim()) {
      setError("Please enter an email address.");
      return;
    }

    setError("");
    setCheckedResult(null);
    setIsLoading(true);
    const response = await dispatch(
      organisationEmailCheckAction({ email: email.trim() }),
    );
    if (response?.payload) {
      setCheckedResult(response.payload);
      if (response?.error) {
        setError(
          response?.payload?.message || "Unable to check this email right now.",
        );
      }
    } else {
      setError("Unable to check this email right now.");
    }
    setIsLoading(false);
  };

  const handleSendInviteClick = () => {
    if (!canSendInvite) return;
    setIsAgreementAccepted(false);
    setShowAgreementModal(true);
  };

  const handleConfirmSendInvite = async () => {
    if (!canSendInvite) return;

    setError("");
    setIsInviteLoading(true);

    const invitePayload = {
      groupId: organisationGroupId,
      email:
        checkedType === "NON_SUPER_ADMIN"
          ? checkedPayload?.school?.schoolAccountOwnerEmail
          : checkedPayload?.email || email.trim(),
      inviteType: checkedType,
      schoolId: checkedSchool?._id,
    };

    const response = await dispatch(
      organisationSendInviteAction(invitePayload),
    );
    console.log("organisationSendInviteAction response", response?.payload);

    if (response?.error) {
      setError(
        response?.payload?.message || "Unable to send invite right now.",
      );
      setShowAgreementModal(false);
    } else {
      if (onInviteSent) {
        onInviteSent();
      }
      toast.success(
        response?.payload?.data?.message ||
          response?.payload?.message ||
          "Invitation email sent successfully",
        {
          duration: 3000,
        },
      );
      handleHide();
    }

    setIsInviteLoading(false);
  };

  const handleHide = () => {
    setEmail("");
    setError("");
    setCheckedResult(null);
    setShowAgreementModal(false);
    handleClose();
  };

  return (
    <>
      <Modal
        size="lg"
        show={show && !showAgreementModal}
      onHide={handleHide}
      className="comn-modal-set create"
      centered
    >
      <Modal.Header className="d-block" style={{ border: "0" }}>
        <Row>
          <Col lg={12} className="d-flex justify-content-center mb-4">
            <div>
              <Modal.Title className="p-0">
                Invite Member Organisation
              </Modal.Title>
              <p className="text-center mb-0">
                Search by email to invite an organisation
              </p>
            </div>
          </Col>
        </Row>
        <div className="modal-right">
          <button className="menu-dots" onClick={handleHide}>
            <img
              src={require("../Assets/Images/dotsweb.svg").default}
              alt="close"
            />
          </button>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col lg={12}>
            <Form.Group className="mb-3">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="email"
                className="input-set"
                placeholder="Enter organisation email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError("");
                  setCheckedResult(null);
                }}
              />
              {error && <div className="error text-danger mt-1">{error}</div>}
            </Form.Group>
          </Col>
        </Row>
        {checkedResult && (
          <Row>
            <Col lg={12}>
              <div className="cmn-card-color p-3 mb-2">
                {checkedMessage && <p className="mb-2">{checkedMessage}</p>}

                {checkedSchool && (
                  <div>
                    <p className="mb-1">
                      <strong>School:</strong>{" "}
                      {checkedSchool?.schoolName ||
                        checkedSchool?.name ||
                        "N/A"}
                    </p>
                    {(checkedSchool?.schoolEmail ||
                      checkedPayload?.schoolEmail) && (
                      <p className="mb-1">
                        <strong>Super Admin Email:</strong>{" "}
                        {checkedSchool?.schoolEmail ||
                          checkedPayload?.schoolEmail}
                      </p>
                    )}
                    {checkedSchool?.address && (
                      <p className="mb-0">
                        <strong>Address:</strong> {checkedSchool.address}
                      </p>
                    )}
                  </div>
                )}
              </div>
            </Col>
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer className="border-none justify-content-center">
        <Button
          variant="primary"
          className="modal-f-btn"
          onClick={handleSearch}
          disabled={isLoading}
        >
          {isLoading ? "Searching..." : "Search"}
        </Button>
        <Button
          variant="primary"
          className="modal-f-btn"
          onClick={handleSendInviteClick}
          disabled={
            !canSendInvite ||
            isInviteLoading ||
            checkedType === "NOT_REGISTERED" ||
            checkedType === "ORGANISATION"
          }
        >
          {isInviteLoading ? "Sending..." : "Send Invite"}
        </Button>
      </Modal.Footer>
      </Modal>

      {/* Dummy Agreement Modal */}
      <Modal
        show={showAgreementModal}
        onHide={() => setShowAgreementModal(false)}
        centered
        size="md"
        className="comn-modal-set"
      >
        <Modal.Header closeButton style={{ borderBottom: "1px solid #dee2e6" }}>
          <Modal.Title>Organisation Group Agreement</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "400px", overflowY: "auto" }}>
          <h5>Terms and Conditions</h5>
          <p>
            By sending this invitation, you agree to the following terms and conditions:
          </p>
          <ul>
            <li className="mb-2">You confirm that the invited organisation meets the criteria for joining this group.</li>
            <li className="mb-2">You agree to share necessary group details and resources with the invited organisation upon their acceptance.</li>
            <li className="mb-2">You understand that the invited organisation will be subject to the overarching privacy policies and platform agreements.</li>
            <li>You accept responsibility for managing the permissions and access levels of the invited organisation.</li>
          </ul>
          <Form.Group className="mb-1 mt-4">
            <Form.Check
              type="checkbox"
              id="agreement-checkbox-modal"
              label="I have read and accept the terms and conditions"
              checked={isAgreementAccepted}
              onChange={(e) => setIsAgreementAccepted(e.target.checked)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-none mt-2">
          <Button variant="secondary" onClick={() => setShowAgreementModal(false)} className="modal-f-btn" style={{ background: "#6c757d", color: "#fff", borderColor: "#6c757d" }} disabled={isInviteLoading}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirmSendInvite} className="modal-f-btn" disabled={!isAgreementAccepted || isInviteLoading}>
            {isInviteLoading ? "Sending..." : "Accept & Send Invite"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default InviteMemberOrganisationModal;
